import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import GridLayout from 'components/Layout/GridLayout';
import SecurityLock from 'components/Icons/SecurityLock';

import comodo from 'assets/images/comodo.png';
import style from './style.scss';

const Heading = ({ heading = '', subHeading = '', className = 'medium-12', isCardVisible = false }) => (
  // Heading
  <div className={`cell small-12 form-headline ${className}`}>
    <h2>{heading}</h2>
    <p className="p-large">{subHeading}</p>
    {
      isCardVisible &&
      <GridLayout className="security hide-for-large">
        <div className={cn('cell small-9 ssl', style.encryption)}>
          <SecurityLock width="28" className={style.securityLock} />
          <p className={cn('p-small', style.noBottomMargin)}><strong>128-bit SSL</strong> protection and strict encryption</p>
        </div>
        <div className="cell small-3 certificate">
          <img src={comodo} alt="" className="setigo-image" />
        </div>
      </GridLayout>
    }
  </div>
  // End Heading
);

Heading.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  className: PropTypes.string,
  isCardVisible: PropTypes.bool,
};

export default Heading;
